import { IInfoTeamPlayers } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface GroupFacts {
  group_facts: { [key: string]: IInfoTeamPlayers };
}

const initialState: GroupFacts = {
  group_facts: {},
};

const groupFactsSlice = initReducer({
  name: "group-facts",
  initialState,
  reducers: {
    setGroupFacts: (state: GroupFacts, action: PayloadAction<IInfoTeamPlayers>) => {
      state.group_facts[action.payload.groupId] = action.payload;
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<GroupFacts> = {
  key: "group-facts",
  storage: AsyncStorage,
};

export const groupFactsActions = groupFactsSlice.actions;

export default createPersistReducer(persistConfig, groupFactsSlice.reducer);
